export const SET_PAGE = "SET_PAGE";
export const SAVE_CODE = "SAVE_CODE";
export const RESET_CODE = "RESET_CODE";
